import React, { createContext, useContext, useRef } from 'react';

// Context für die CalendarStrips-Ref
const CalendarStripsContext = createContext();

// Provider-Komponente
export const CalendarStripsProvider = ({ children }) => {
  const calendarStripsRef = useRef(null);

  return (
    <CalendarStripsContext.Provider value={{ calendarStripsRef }}>
      {children}
    </CalendarStripsContext.Provider>
  );
};

// Hook zum Verwenden des CalendarStrips-Contexts
export const useCalendarStrips = () => {
  const context = useContext(CalendarStripsContext);
  if (context === undefined) {
    throw new Error('useCalendarStrips must be used within a CalendarStripsProvider');
  }
  return context;
};
